import {ClientReportFile, ClientReportFileColumn} from "./domain";
import {ClientReportFileListRowItem} from "./ClientReportFileRowItem";

type ClientReportFileTableProps = {
    files: ClientReportFile[];
    onDelete?: (fileGuid: string) => Promise<void>;
    deleteDisabledReason?: string | null;
}

export const ClientReportFileColumns: Readonly<ClientReportFileColumn[]> = [
    {name: 'File Name', attr: 'fileName'},
    {name: 'File Type', attr: 'fileExtension'},
];

export function ClientReportFileTable({files, onDelete, deleteDisabledReason}: ClientReportFileTableProps) {
    return (
        <table className='table-auto w-full'>
            <thead>
            <tr className='text-left select-none text-xs text-gray-portal-table-title'>
                {
                    ClientReportFileColumns.map((column) => (
                        <th
                            key={column.attr}
                            className={'font-light' + (column.attr === 'fileName' ? ' pl-4' : '')
                            }
                        >
                            <div className='flex items-center'>
                                <div>
                                    {column.name}
                                </div>
                            </div>
                        </th>
                    ))
                }
                {onDelete && <th/>}
            </tr>
            </thead>
            <tbody>
            {
                files.map((file) =>
                    <ClientReportFileListRowItem key={file.guid} file={file} onDelete={onDelete} deleteDisabledReason={deleteDisabledReason}/>
                )
            }
            </tbody>
        </table>
    );
}
